import { ref, uploadBytesResumable, getDownloadURL, deleteObject } from 'firebase/storage';
import { storage } from './config';

export const uploadImage = (file, path, onProgress) => {
  return new Promise((resolve, reject) => {
    const storageRef = ref(storage, path);
    const task = uploadBytesResumable(storageRef, file);
    task.on('state_changed',
      snap => { if (onProgress) onProgress(Math.round((snap.bytesTransferred / snap.totalBytes) * 100)); },
      reject,
      async () => resolve(await getDownloadURL(task.snapshot.ref))
    );
  });
};

export const uploadProductImages = async (files, productId, onProgress) => {
  const urls = [];
  for (let i = 0; i < files.length; i++) {
    const ext = files[i].name.split('.').pop();
    const url = await uploadImage(
      files[i],
      `products/${productId}/${Date.now()}_${i}.${ext}`,
      p => onProgress && onProgress(Math.round((i / files.length) * 100 + p / files.length))
    );
    urls.push(url);
  }
  return urls;
};

export const uploadCollectionImage = async (file, id) => {
  const ext = file.name.split('.').pop();
  return uploadImage(file, `collections/${id}/${Date.now()}.${ext}`);
};

export const deleteImageByUrl = async (url) => {
  try { await deleteObject(ref(storage, url)); } catch (e) { console.warn('Delete error:', e.message); }
};
